import { max, email, min_value } from '@vee-validate/rules';

export default {
    data() {
        return {
            customerConfiguration: {
                type: 'customers',
                label: 'Customers',
                importModes: [
                    {value:'add', text:'Add New (Skip when account number already present)'},
                    {value:'update', text:'Update (Skip when account number not present, update when found)'},
                    {value:'addAndUpdate', text:'Add and Update'}
                ],
                sampleNotes: [
                    'State must be provided as a valid abbreviation.'
                ],
                fields: [
                    {
                        key: 'AccountNumber',
                        label: 'Account Number',
                        hasWarningCalculator: (value, row, checkOriginalData) => {
                            return (
                                !this.isEmpty(value)
                                && max(value, { length: 75 }) !== true
                                || this.isDuplicatedOnImportNumber(value, checkOriginalData)
                            );
                        },
                        warningDefault: null,
                        rules: {
                            max: { length: 75 },                            
                            'unique-value': {
                                isDuplicated: this.isDuplicatedOnImportNumber
                            },
                        },
                        samples: ['"Cust-0040518"', '"Cust-0040519"']
                    },
                    {
                        key: 'FirstName',
                        label: 'First Name',
                        hasErrorCalculator: value => {
                            return (
                                this.isEmpty(value) ||
                                max(value, { length: 50 }) !== true
                            );
                        },

                        rules: {
                            max: { length: 50 },
                            required: true
                        },
                        samples: ['"Sophia"', '"Liam"']
                    },
                    {
                        key: 'LastName',
                        label: 'Last Name',
                        hasErrorCalculator: value => {
                            return (
                                this.isEmpty(value) ||
                                max(value, { length: 50 }) !== true
                            );
                        },

                        rules: {
                            max: { length: 50 },
                            required: true
                        },
                        samples: ['"Miller"', '"Garcia"']
                    },
                    {
                        key: 'StudentID',
                        label: 'Student ID',
                        hasWarningCalculator: value => {
                            return max(value, { length: 75 }) !== true;
                        },
                        warningDefault: null,
                        rules: {
                            max: { length: 75 }
                        },
                        samples: ['"MI7085"', '"GA71505"']
                    },
                    {
                        key: 'AlternateLookupID',
                        label: 'Alternate Lookup ID',
                        hasWarningCalculator: value => {
                            return max(value, { length: 75 }) !== true;
                        },
                        warningDefault: null,
                        rules: {
                            max: { length: 75 }
                        },
                        samples: ['"12342143"', '"1234254365"']
                    },
                    {
                        key: 'EmailAddress',
                        label: 'Email Address',
                        hasWarningCalculator: value => {
                            if (this.isEmpty(value)) {
                                return false;
                            }
                            return (
                                email(value) !== true ||
                                max(value, { length: 254 }) !== true
                            );
                        },
                        warningDefault: null,
                        rules: 'email|max:254',
                        samples: ['"sm101@mail.com"', '"lg@mail.com"']
                    },

                    {
                        key: 'ContactAddress',
                        label: 'Contact Address',
                        hasWarningCalculator: value => {
                            return max(value, { length: 255 }) !== true;
                        },
                        warningDefault: '',
                        rules: 'max:255',
                        samples: ['"4825 N 1st Street"', '"1487 N 2nd Street"']
                    },
                    {
                        key: 'ContactCity',
                        label: 'Contact City',
                        hasWarningCalculator: value => {
                            return max(value, { length: 50 }) !== true;
                        },
                        warningDefault: '',
                        rules: 'max:50',
                        samples: ['"Athens"', '"Phoenix"']
                    },

                    {
                        key: 'ContactState',
                        label: 'Contact State',
                        dataType: 'states',
                        comparisonProperty: 'abbreviation',
                        hasWarningCalculator: value => {
                            return (
                                value != '' &&
                                value != undefined &&
                                min_value(value, { min: 0 }) !== true
                            );
                        },
                        warningDefault: null,
                        rules: 'min_value:0',
                        samples: ['"OK"', '"AZ"']
                    },
                    {
                        key: 'ContactPostalCode',
                        label: 'Contact Postal Code',
                        hasWarningCalculator: value => {
                            return max(value, { length: 20 }) !== true;
                        },
                        warningDefault: '',
                        rules: 'max:20',
                        samples: ['"68747"', '"87516"']
                    },

                    {
                        key: 'ShippingAddress',
                        label: 'Shipping Address',
                        hasWarningCalculator: value => {
                            return max(value, { length: 255 }) !== true;
                        },
                        warningDefault: '',
                        rules: 'max:255',
                        samples: [
                            '"223 N 1st Street"',
                            '"1487 N 2nd Street"',
                            '"1212 S 1st Street"'
                        ]
                    },
                    {
                        key: 'ShippingCity',
                        label: 'Shipping City',
                        hasWarningCalculator: value => {
                            return max(value, { length: 50 }) !== true;
                        },
                        warningDefault: '',
                        rules: 'max:50',
                        samples: ['"Vernon"', '"Phoenix"']
                    },

                    {
                        key: 'ShippingState',
                        label: 'Shipping State',
                        dataType: 'states',
                        comparisonProperty: 'abbreviation',
                        hasWarningCalculator: value => {
                            return (
                                value != '' &&
                                value != undefined &&
                                min_value(value, { min: 0 }) !== true
                            );
                        },
                        warningDefault: null,
                        rules: 'min_value:0',
                        samples: ['"CA"', '"AZ"']
                    },
                    {
                        key: 'ShippingPostalCode',
                        label: 'Shipping Postal Code',
                        hasWarningCalculator: value => {
                            return max(value, { length: 20 }) !== true;
                        },
                        warningDefault: '',
                        rules: 'max:20',
                        samples: ['"90058"', '"87516"']
                    },

                    {
                        key: 'PrimaryPhone',
                        label: 'Primary Phone',
                        hasWarningCalculator: value => {
                            return max(value, { length: 26 }) !== true;
                        },
                        warningDefault: '',
                        rules: 'max:26',
                        samples: ['"1-555-444-5555"', '"1-555-789-3333"']
                    },
                    {
                        key: 'PrimaryPhoneExtension',
                        label: 'Primary Phone Extension',
                        hasWarningCalculator: value => {
                            return max(value, { length: 6 }) !== true;
                        },
                        warningDefault: '',
                        rules: 'max:6',
                        samples: ['"555"', '""']
                    },

                    {
                        key: 'SecondaryPhone',
                        label: 'Secondary Phone',
                        hasWarningCalculator: value => {
                            return max(value, { length: 26 }) !== true;
                        },
                        warningDefault: '',
                        rules: 'max:26',
                        samples: ['"1-555-444-1111"', '"1-555-789-2222"']
                    },
                    {
                        key: 'SecondaryExtension',
                        label: 'Secondary Extension',
                        hasWarningCalculator: value => {
                            return max(value, { length: 6 }) !== true;
                        },
                        warningDefault: '',
                        rules: 'max:6',
                        samples: ['"1234"', '""']
                    },
                    {
                        key: 'IsActive',
                        label: 'Is Active',
                        dataType: 'yesNoOptions',
                        hasWarningCalculator: value => {
                            return !this.matchesExistingObject(value);
                        },
                        warningDefault: true,
                        rules: 'min_value:0',
                        samples: ['Yes', 'No']
                    }
                ],
                canRunNoParse: true,
                cronJobTypeId: 11
            }
        };
    },    
    methods: {
       isDuplicatedOnImportNumber(number, checkOriginalData) {
            return (
                number != '' &&
                this.loadedData.filter(x => x.AccountNumber === number||
                    (checkOriginalData &&
                        x.originalData?.AccountNumber === number)).length > 1
            );
        },
    }
};
